import Cookies from "js-cookie"

/**
 * Set the MS Cookie
 * 
 * @param {Element} target 
 * @param {} targetParent 
 */
const _setMSCookie = () => {
  Cookies.set('ms_cookieconsent', 'true', { expires: 365 })
}

/**
 * Add On Click Event Listener to Cookie Dismiss Element
 * 
 * @param {Element} target 
 * @param {Element} targetParent 
 */
const cookieControlOnClick = (
  target = false, 
  targetParent = false
) => {
  target.addEventListener('click', (ev) => {
    _setMSCookie()

    targetParent.classList.add('ms-cookie-bar--dismiss')
    targetParent.addEventListener('transitionend', (ev) => {
      targetParent.style.display = 'none'
    })
  })
}

const initCookies = () => {
  let cookieDismissEl = document.querySelector('.js-cookie-dismiss')
  let cookieBarEl = document.querySelector('.js-cookie-bar')

  if (cookieDismissEl && cookieBarEl) {
    if (!Cookies.get('ms_cookieconsent')) {
      cookieControlOnClick(cookieDismissEl, cookieBarEl)
    } else {
      cookieBarEl.remove()
    }
  }
}

export { initCookies }